import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material"
import axios from "../../apiClient/axios"
import { IEvent, IEventStatus } from "bets.oddprovider.lib.common.ts/models"
import { ApiClientUtils } from "fwork-jsts-common/src/apiClient"
import { FormItemStyled } from "fwork.react.apptemplate"
import { useSnackbar } from "notistack"
import React, { useEffect, useState } from "react"
import { EventsStatusApiClient } from "../../apiClient/eventsStatus"
import { DEFAULTGAP } from "../../globals"

export const EventStatusComponent = (props: {
  data?: IEvent,
  onChange: ((event: SelectChangeEvent<number>, child: React.ReactNode) => void) | undefined
}) => {
  const [data, setData] = useState<IEventStatus[]>([])
  const { enqueueSnackbar } = useSnackbar()

  const [gettingData, setGettingData] = useState<boolean>(false)
  const getData = async (filter: string | undefined) => {
    if (gettingData) return
    setGettingData(true)

    try {
      const response = await new EventsStatusApiClient(axios).get({
        where: {
          name: { $regex: filter || '', $options: 'i' }
        },
        sort: { name: 1 }
      })

      setData(response.data?.payload ?? [])
      return response.data?.payload
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    } finally {
      setGettingData(false)
    }
  }

  useEffect(() => {
    getData(undefined)
  }, [])

  return data.length ? <FormItemStyled gap={DEFAULTGAP}>
    <FormControl fullWidth>
      <InputLabel id="status-label">Status</InputLabel>
      <Select
        labelId="status-label"
        id="input-label"
        value={props.data?.status_id ?? ''}
        label={data.filter(s => s.id == props.data?.status_id)[0]?.name ?? ''}
        onChange={props.onChange}
      >
        {data.map(s => <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>)}
      </Select>
    </FormControl>
  </FormItemStyled> : <></>
}